<template>
  <svg
    id="flag-icon-css-de"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    :height="height"
  >
    <path fill="#ae1c28" d="M0 0h640v160H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <path fill="#21468b" d="M0 320h640v160H0z" />
  </svg>
</template>

<script>
export default {
  name: 'NlFlag',
  props: {
    height: {
      type: String,
      default: '20px'
    }
  }
}
</script>
